import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { PressHero, BrandFacts, BioBlocks, PhotoDownloads, PressLinks } from '@/components/press/PressSections';
import { speaker } from '@/data/speaker';
import '@/styles/press.css';

const PressPage = () => (
  <>
    <SeoHead
      route="/imprensa"
      lang="pt-BR"
      title="Kit de imprensa — Johnny Vaz"
      description="Bios oficiais, fotos em alta resolução, títulos aprovados e links para divulgação de eventos com Johnny Vaz."
      image={`${speaker.site}/images/og/palestrante-og.png`}
    />
    <Navbar />
    <main id="press-content" className="pulse-page" tabIndex={-1}>
      <PressHero />
      <BrandFacts />
      <BioBlocks />
      <PhotoDownloads />
      <PressLinks />
    </main>
    <Footer />
  </>
);

export default PressPage;
